import NotificationsModel from 'models/NotificationsModel';

NotificationsStore.dispatchToken = MakeShiftEmployeeDispatcher.register(
  NotificationsStore.dispatchCallback,
);
NotificationsStore.notifications = {};

NotificationsStore.onNotificationsHandler = function (notificationsData, response) {
  NotificationsStore.notifications = notificationsData;
  NotificationsStore.trigger('notifications:load:success');
};

NotificationsStore.onNotificationsError = function (error, response) {
  // console.log(JSON.stringify(error));
  NotificationsStore.trigger('notifications:load:error', response);
};

NotificationsStore.getAllNotifications = function () {
  let data = {};
  this.models.map((d) => {
    if (d.attributes.data) {
      data = d.attributes.data;
    }
  });
  return _.sortBy(data, (notification) => { notification.date }).reverse();
};

NotificationsStore.updateAllLocalNotificationsAsRead = function () {
  this.models.forEach((model) => {
    let notifications = model.attributes.data;
    if (notifications) {
      notifications.forEach((notification) => {
        notification.is_read = true;
      });
    }
  });
}

NotificationsStore.updateLocalNotificationAsRead = function (notificationId) {
  this.models.map((model) => {
    let notifications = model.attributes.data;
    if (notifications) {
      notifications.filter((notification) => {
        if (notification.notification_id === notificationId) {
          notification.is_read = true;
        }
      })
    }
  });
}
